/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignCreateFromAtsJob } from '../../axios/campaignCreateFromAtsJob'
import type {
	CampaignCreateFromAtsJobError,
	CampaignCreateFromAtsJobRequest,
	CampaignCreateFromAtsJobResponse,
} from '../../types/CampaignCreateFromAtsJob'

export const campaignCreateFromAtsJobMutationKey = () => [{ url: '/campaigns/from-ats-job' }] as const

export type CampaignCreateFromAtsJobMutationKey = ReturnType<typeof campaignCreateFromAtsJobMutationKey>

export type CampaignCreateFromAtsJobVariables = {
	data: CampaignCreateFromAtsJobRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::createFromAtsJob */
export function useCampaignCreateFromAtsJob<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignCreateFromAtsJobResponse,
		AxiosError<CampaignCreateFromAtsJobError>,
		CampaignCreateFromAtsJobVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignCreateFromAtsJobMutationKey(),
		mutationFn: ({ data }: CampaignCreateFromAtsJobVariables) =>
			campaignCreateFromAtsJob(data, config).then(res => res.data),
		...options,
	})
}
